import { Col, Layout, Row, Select, Table } from "antd";

import { Helmet } from "react-helmet-async";
import Navbar from "../../Components/Navbar/Navbar";
import PageHeader from "../../Components/PageHeader/PageHeader";
import {
  formatDate,
  formatNumbers,
  handleChangePage,
  handleExportToExcel,
  handleExportToPDF,
  handlePageSizeChange,
} from "../../Utils/Common";
import CustomTable from "../../Components/Table/CustomTable";
import { useEffect, useState } from "react";
import { getRequest } from "../../Utils/ApiCalls";
import PersistentFooter from "../../Components/PersistentFooter/PersistentFooter";

const { Option } = Select;

const AccountReceivableReport = () => {
  const [loading, setLoading]: any = useState("");
  const [filterConfig, setFilterConfig]: any = useState({
    page: 1,
    // date_from: formatDate(dateRange[0], "YYYY-MM-DD"),
    // date_to: formatDate(dateRange[1], "YYYY-MM-DD"),
  });
  const [dataSize, setDataSize] = useState(0);
  const [dataSource, setDataSource]: any = useState([]);
  const [branches, setBranches]: any = useState([]);
  const [totals, setTotals]: any = useState([]);

  const columns = [
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer",
      render: (text: string, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{text}</strong>;
        }
        return text || `Customer ${record.customer_id}`;
      },
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px" }}>{formatNumbers(data || 0)}</div>
        );
      },
    },
    {
      title: "1-30 Days",
      dataIndex: "days_01_31",
      key: "days_01_31",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px" }}>{formatNumbers(data || 0)}</div>
        );
      },
    },
    {
      title: "31-60 Days",
      dataIndex: "days_31_60",
      key: "days_31_60",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px" }}>{formatNumbers(data || 0)}</div>
        );
      },
    },
    {
      title: "61-90 Days",
      dataIndex: "days_61_90",
      key: "days_61_90",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px" }}>{formatNumbers(data || 0)}</div>
        );
      },
    },
    {
      title: "Over 90 Days",
      dataIndex: "over_90",
      key: "over_90",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px" }}>{formatNumbers(data || 0)}</div>
        );
      },
    },
    {
      title: "Total Balance",
      dataIndex: "total_balance",
      key: "total_balance",
      align: "right",
      render: (data: any, record: any) => {
        if (record.customer_id === "Total") {
          return <strong>{formatNumbers(data || 0)}</strong>;
        }
        return (
          <div style={{ fontSize: "12px", fontWeight: "bold" }}>
            {formatNumbers(data || 0)}
          </div>
        );
      },
    },
  ];

  function handleFilterChange(value: any, field: any) {
    if (field === "dates") {
      setFilterConfig((prev: any) => ({
        ...prev,
        date_from: formatDate(value[0], "YYYY-MM-DD"),
        date_to: formatDate(value[1], "YYYY-MM-DD"),
      }));
    } else {
      setFilterConfig((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    }
  }

  function exportToExcel() {
    // const tableData = getTableData();
    handleExportToExcel(dataSource, columns, "AccountReceivableReport");
  }

  function exportToPDF() {
    // const tableData = getTableData();
    handleExportToPDF(
      dataSource,
      columns,
      "AccountReceivableReport.pdf",
      {
        title: "Account Receivable Report",
        content: `Generated on ${new Date().toLocaleString()}`,
      },
      `Total Records: ${dataSource.length}`,
    );
  }

  async function fetchBranches() {
    setBranches([]);
    setLoading("fetch");
    const response = await getRequest(`branches/get`, true);
    if (response.success) {
      var data = response.data.data.map((info: any) => ({
        ...info,
        branch_id: info.id,
        branch_name: info.name,
      }));
      setBranches(data);
    }

    setLoading("");
  }

  async function fetchTableData() {
    setDataSource([]);
    setLoading("fetch");
    try {
      // const response: any = await getRequest(
      //   `reports/get_account_receivables`,
      //   filterConfig,
      //   true,
      // );

      const response = {
        success: true,
        data: {
          size: 2,
          data: [
            {
              customer_name: "Jasper Drake",
              current: "0.0000",
              days_01_31: "0.0000",
              days_31_60: "0.0000",
              days_61_90: "90000.0000",
              over_90: "0.0000",
              total_balance: "90000.0000",
            },
            {
              customer_name: "Jovita, Michael",
              current: "0.0000",
              days_01_31: "0.0000",
              days_31_60: "0.0000",
              days_61_90: "0.0000",
              over_90: "0.0000",
              total_balance: "0.0000",
            },
          ],
        },
      };

      if (response?.success) {
        if (response?.success) {
          const raw = response.data?.data ?? response.data ?? [];
          const rawData = Array.isArray(raw) ? raw : [];

          const _totals = {
            customer_name: "TOTAL",
            current: 0,
            days_01_31: 0,
            days_31_60: 0,
            days_61_90: 0,
            over_90: 0,
            total_balance: 0,
          };

          rawData.forEach((item: any) => {
            _totals.current += parseFloat(item.current ?? 0);
            _totals.days_01_31 += parseFloat(item.days_01_31 ?? 0);
            _totals.days_31_60 += parseFloat(item.days_31_60 ?? 0);
            _totals.days_61_90 += parseFloat(item.days_61_90 ?? 0);
            _totals.over_90 += parseFloat(item.over_90 ?? 0);
            _totals.total_balance += parseFloat(item.total_balance ?? 0);
          });

          setTotals(_totals);

          setDataSource(rawData);
          setDataSize(response.data.size);
        }
      } else {
        setDataSource([]);
        setDataSize(0);
      }
    } catch (error) {
      console.error("Error fetching account receivable data:", error);
      setDataSource([]);
      setDataSize(0);
    } finally {
      setLoading("");
    }
  }

  useEffect(() => {
    fetchBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className="page">
      <Helmet>
        <title>Agua Lab ERP System</title>
      </Helmet>
      <Navbar />
      <Layout>
        <Row className="px-3 pt-20 md:px-10 md:pb-10 md:pt-8 w-screen md:w-full pb-[50px] sm:pb-0 overflow-scroll text-textColor">
          <Col xs={24}>
            <PageHeader
              title="Account Receivable Report"
              withDateRangeFilter={false}
              withAddButton={false}
              withExportDropdownButton={true}
              disableExportButton={dataSource?.length === 0}
              onExportToExcel={() => exportToExcel()}
              onExportToPDF={() => exportToPDF()}
              withSearchBtn={true}
              searchPlaceholder="Search customer"
              onSearch={(value: any) =>
                setFilterConfig((prev: any) => ({
                  ...prev,
                  search: value,
                }))
              }
            />
          </Col>
          <Col xs={24} md={12} lg={8} className="mb-1">
            <span>
              <strong>Filter By:</strong>
            </span>
          </Col>
          <Col span={24} className="mb-3">
            <Row>
              <Col xs={24} md={12} lg={5} className="mb-2 me-2 mb-lg-0">
                <Select
                  className="w-full"
                  showSearch
                  placeholder="Select branch"
                  value={filterConfig.branch_id || ""}
                  onChange={(value) => handleFilterChange(value, "branch_id")}
                  allowClear
                  filterOption={(input: string, option?: any) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value="">All Branches</Option>
                  {branches.map((branch: any) => (
                    <Option key={branch.id} value={branch.id}>
                      {branch.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <div className="custom-table-header table-container overflow-auto">
              <div className="min-w-[800px]">
                <CustomTable
                  data={dataSource}
                  columns={columns}
                  loading={loading}
                  size="small"
                  pagination={{
                    current: filterConfig.page,
                    total: dataSize,
                    showSizeChanger: true,
                    onChange: (page: number) =>
                      handleChangePage(page, setFilterConfig),
                    onShowSizeChange: (_: number, size: number) =>
                      handlePageSizeChange(size, setFilterConfig),
                  }}
                  summaryData={() => (
                    <Table.Summary fixed>
                      <Table.Summary.Row className="font-bold">
                        <Table.Summary.Cell index={0} colSpan={1}>
                          TOTAL
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.current)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.days_01_31)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.days_31_60)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.days_61_90)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.over_90)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0} colSpan={1} align="right">
                          {formatNumbers(totals.total_balance)}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
      <PersistentFooter />
    </Layout>
  );
};

export default AccountReceivableReport;
